<template>
  <div v-if="show" class="table">
    <div v-if="hasOrder" bold class="table-going" @click="handleGoToOrder">
      <i class="iconfont dm-Ongoing" />
      <span class="text">{{ $t('list.nopenemails') }}</span>
      <i class="right iconfont dm-right" />
    </div>
    <div v-else class="table-num">
      <i class="iconfont dm-a-ChairTable1" />
      <span bold class="text">{{ $t('list.sayTableNum') }}</span>
      <span bold class="right">{{ tableNumber }}</span>
    </div>
  </div>
</template>

<script setup>
import { defineProps, computed } from 'vue';
import { setTable, getTable, clearTable } from '../../../utils/common';
import { use18n, useIns } from '../../../utils/v2_helper/common';
import { useRouter } from '../../../utils/v2_helper/router';

const app = useIns();
const { $t } = use18n();
const router = useRouter();

const props = defineProps({ tableNumber: { type: String, default: '' } });

const tableType = computed(() => $t(`list.table${app.storeInfo.businessType}`));
const hasOrder = computed(() => {
  if (!app.isFullDineIn) return false;
  const { orderId } = app.fullDineInTableData?.cart || {};
  return !!orderId;
});
const show = computed(() => {
  const { isFullDineIn, tableNumber, isApartment, isRoomService } = app;
  return (
    tableNumber &&
    (isFullDineIn || (app.isDine && !isApartment && !isRoomService))
  );
});

function handleGoToOrder() {
  // 只能是购物车中的orderId
  const { orderId } = app.fullDineInTableData?.cart || {};
  router.push({
    path: `/${app.storeUrl}/ongoing`,
    query: { orderId },
  });
}
</script>

<style lang="scss" scoped>
.table {
  padding: 12px;
  background: #fff;
  &-going,
  &-num {
    min-height: 44px;
    padding: 0 14.5px;
    border-radius: 8px;
    border: solid 1px $black;
    display: flex;
    align-items: center;
    .text {
      margin-left: 8px;
    }
    .iconfont {
      font-size: 16px;
    }
    .dm-a-ChairTable1 {
      font-size: 20px;
    }
    .right {
      font-size: 18px;
      color: #000000;
      margin-left: auto;
      max-width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      line-clamp: 2;
      -webkit-line-clamp: 2;
      word-break: break-all;
    }
  }
}
</style>
